import { makeStyles } from '@material-ui/core/styles'
import { interactiveCardHoverStyles } from 'lib/styles/interactive-card-hover'

export const useStyles = makeStyles(theme => ({
  root: {
    margin: '45px',
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
      marginBottom: '70px',
    },
  },
  emptyStateContent: {
    padding: theme.spacing(4, 2),
  },
  listToolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  listToolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: '1 1 auto',
    minWidth: 0,
  },
  categoryLabel: {
    fontSize: '1.125rem',
    fontWeight: 700,
    lineHeight: 1.3,
    flexShrink: 0,
    margin: 0,
  },
  toolbarActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
    marginLeft: 'auto',
  },
  filterButton: {
    height: 40,
    borderRadius: 8,
    fontWeight: 500,
    flexShrink: 0,
    borderColor: '#C4C7C9',
    color: '#172024',
    '& .MuiButton-endIcon': {
      color: '#6B7C87',
    },
  },
  filterButtonActive: {
    borderColor: theme.palette.primary.main,
    backgroundColor: '#E0EAFF',
    color: '#001C57',
    fontWeight: 600,
    '& .MuiButton-endIcon': {
      color: '#001C57',
    },
    '&:hover': {
      backgroundColor: '#D4E2FF',
      borderColor: theme.palette.primary.main,
    },
  },
  filterMenuPaper: {
    marginTop: theme.spacing(0.5),
    minWidth: 200,
  },
  filterMenuContent: {
    padding: theme.spacing(1.5, 2),
    boxSizing: 'border-box',
  },
  filterForm: {
    margin: 0,
    padding: 0,
    border: 0,
    minWidth: 0,
  },
  filterLegend: {
    display: 'block',
    fontSize: '0.6875rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#6B7C87',
    padding: 0,
    margin: 0,
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  filterRadioGroup: {
    padding: 0,
    margin: 0,
  },
  filterRadioLabel: {
    margin: 0,
    width: '100%',
    minHeight: 40,
    marginLeft: 0,
    marginRight: 0,
    '& .MuiFormControlLabel-label': {
      fontSize: '0.875rem',
      lineHeight: '20px',
      color: '#172024',
    },
    '& .MuiRadio-root': {
      color: '#40484C',
      padding: theme.spacing(1),
    },
    '& .MuiRadio-colorPrimary.Mui-checked': {
      color: '#0053FF',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: 288,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    '&.MuiPaper-rounded': {
      borderRadius: '12px',
    },
    '&.MuiPaper-root': {
      boxShadow: 'none',
    },
    ...interactiveCardHoverStyles(theme),
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '0 !important',
    '&.MuiCardContent-root:last-child': {
      paddingBottom: '0 !important',
    },
  },
  cardInner: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    paddingTop: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
  },
  cardDetails: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    cursor: 'pointer',
  },
  badgeRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginBottom: theme.spacing(2),
  },
  iconBadge: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg, & .MuiSvgIcon-root': {
      width: 14,
      height: 14,
      fontSize: 14,
    },
  },
  chipLessonPack: {
    backgroundColor: '#D2DEE3',
    color: '#172024',
  },
  chipRemaining: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
  chip: {
    borderRadius: 9999,
    height: '22px',
    fontSize: '10px',
    border: 'none',
    fontWeight: 500,
  },
  chipInfo: {
    backgroundColor: theme.palette.blue.main,
    color: '#fff',
  },
  chipGiftable: {
    backgroundColor: '#CCDDFF',
    color: '#001C57',
  },
  chipGifted: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
    '& .MuiChip-icon': {
      color: '#001C57',
      marginLeft: theme.spacing(0.75),
      '& svg, & .MuiSvgIcon-root': {
        fontSize: 14,
        width: 14,
        height: 14,
      },
    },
    '& .MuiChip-label': {
      paddingRight: theme.spacing(1),
    },
  },
  cardTitle: {
    marginBottom: theme.spacing(2),
    display: '-webkit-box',
    lineClamp: 1,
    WebkitBoxOrient: 'vertical',
    overflow: 'clip',
    textOverflow: 'ellipsis',
    lineHeight: 1.3,
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  metadataRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  metadataItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    minWidth: 0,
    maxWidth: '100%',
  },
  metadataIcon: {
    color: theme.palette.text.secondary,
    width: 14,
    height: 14,
    fontSize: 14,
    flexShrink: 0,
    opacity: 0.85,
  },
  metadataText: {
    color: theme.palette.text.secondary,
    fontSize: '0.8125rem',
    lineHeight: 1.3,
  },
  cardActions: {
    marginTop: 'auto',
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'auto',
    paddingTop: theme.spacing(2),
  },
  cardFooterActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
  },
  tooltipWrap: {
    display: 'inline-flex',
  },
  outlinedIconButton: {
    minWidth: 40,
    width: 40,
    height: 40,
    padding: theme.spacing(1),
    border: '1px solid #C4C7C9',
    borderRadius: '50%',
    color: '#172024',
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#F5F7F8',
      borderColor: '#C4C7C9',
    },
    '& .MuiSvgIcon-root': {
      width: 20,
      height: 20,
      fontSize: 20,
    },
  },
  actionButton: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    minWidth: 'auto',
    flex: '0 0 auto',
  },
  actionContainer: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
}))
